export const selectStyle = {
	width: '100%',
	minWidth: '7.7rem',
	height: '100%',
};
